import {ENDPOINT} from 'config/path'
import {lazy, useEffect} from 'react'
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom'
import {getEmbargoedCountryYN} from 'services/common.service'
import Loadable from 'shared/Loadable'
import PreRoute from './PreRoute'
import {isLoggedIn} from './routes.utils'
import ContactUs from 'features/ContactUs'
import ViewSchedules from 'features/HomePage/ViewSchedules'
import ViewFlightStaus from 'features/HomePage/FlightStatus'
import TrackShipments from 'features/HomePage/TrackShipments'
import {useSelector} from 'react-redux'
import type {RootState} from 'redux/store'

const AuthRoute = Loadable(lazy(async () => await import('Routes/AuthRoute')))
const HomepageRoute = Loadable(lazy(async () => await import('Routes/HomepageRoute')))
const SecureRoute = Loadable(lazy(async () => await import('Routes/SecureRoute')))
const Restricted = Loadable(lazy(async () => await import('features/Restricted')))
const Faq = Loadable(lazy(async () => await import('features/Faq')))
const Logout = Loadable(lazy(async () => await import('shared/Logout')))
const Registration = Loadable(lazy(async () => await import('features/Registration')))
const ResetPassword = Loadable(lazy(async () => await import('features/ResetPassword')))

const PUBLIC_ROUTES = [
    {
        path: ENDPOINT.restricted,
        element: <Restricted />
    },
    {
        path: ENDPOINT.faqpage,
        element: <Faq />
    },
    {
        path: ENDPOINT.inviteUser,
        element: <Registration />
    },
    {
        path: ENDPOINT.resetPassword,
        element: <ResetPassword />
    },
    {
        path: ENDPOINT.contactCPS,
        element: <ContactUs />
    }
]

const MainRoute = () => {
    const navigate = useNavigate()
    const loginDetails = useSelector((state: RootState) => state.login?.loginDetails)
    useEffect(() => {
        const isRestrictedCountry = async () => {
            try {
                const isEmbargoedCountryYN = localStorage.getItem('isEmbargoedCountryYN')
                if (!isEmbargoedCountryYN) {
                    const embargoedCountry = await getEmbargoedCountryYN()
                    const isEmbargoedCountry = embargoedCountry.data
                    localStorage.setItem('isEmbargoedCountryYN', isEmbargoedCountry.toString())
                    return JSON.parse(isEmbargoedCountry)
                }
                return JSON.parse(isEmbargoedCountryYN)
                    ? navigate(ENDPOINT.restricted)
                    : JSON.parse(isEmbargoedCountryYN)
            } catch {
                // Do nothing
                return false
            }
        }
        void isRestrictedCountry()
    }, [])

    const checkIfNotGuestUser = () =>
        loginDetails?.securityParams?.isBranchAdmin ||
        loginDetails?.securityParams?.isBranchUser ||
        loginDetails?.securityParams?.isBranchSuperUser ||
        loginDetails?.securityParams?.isCarrierAdmin ||
        loginDetails?.securityParams?.isCarrierUser ||
        loginDetails?.securityParams?.isServiceAdmin ||
        loginDetails?.securityParams?.isServiceUser

    return (
        <Routes>
            {PUBLIC_ROUTES.map((route) => (
                <Route path={route.path} element={route.element} key={route.path} />
            ))}
            <Route path={`${ENDPOINT.auth}/*`} element={<AuthRoute />} />
            <Route path={`${ENDPOINT.homepage}/*`} element={<HomepageRoute />} />
            <Route
                path={ENDPOINT.register}
                element={
                    isLoggedIn() && checkIfNotGuestUser() ? <Navigate to={ENDPOINT.inviteUser} /> : <Registration />
                }
            />
            <Route
                path={ENDPOINT.branchUserRegister}
                element={isLoggedIn() ? <Registration /> : <Navigate to={ENDPOINT.register} replace />}
            />
            <Route
                path={ENDPOINT.logout}
                element={isLoggedIn() ? <Logout /> : <Navigate to={ENDPOINT.dashboard} replace />}
            />
            <Route
                path='/secure/*'
                element={isLoggedIn() ? <SecureRoute /> : <Navigate to={ENDPOINT.login} replace />}
            />
            <Route path={ENDPOINT.viewSchedule} element={<ViewSchedules />} />
            <Route path={ENDPOINT.viewFlightStatus} element={<ViewFlightStaus />} />
            <Route path={ENDPOINT.trackShipment} element={<TrackShipments />} />
            <Route path='/*' element={isLoggedIn() ? <Navigate to={ENDPOINT.dashboard} replace /> : <PreRoute />} />
        </Routes>
    )
}

export default MainRoute
